import { signOut } from './contexts/UserContext'
import request from 'request-promise'
import { getStatusText } from 'http-status-codes'

const guardedRequest = async (location, requestOptions) => {
  try {
    const options = Object.assign({}, requestOptions, { resolveWithFullResponse: true, simple: false })
    const response = await request(options)
    if (response.statusCode === 401) {
      signOut(location)
      return Promise.reject(new Error('Unauthorized'))
    } else {
      if (response.statusCode >= 200 && response.statusCode < 400) {
        return Promise.resolve(response.body)
      } else {
        return Promise.reject(response)
      }
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

const getStatusTextSafe = (statusCode) => {
  try {
    return getStatusText(statusCode)
  } catch (_) {
    return 'Error'
  }
}

export {
  guardedRequest,
  getStatusTextSafe
}
